import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
 import { TranslateModule } from "@ngx-translate/core";
import { Claims } from "src/app/_models/common/claims";
import { OrgFeedbackTypes } from "src/app/_models/enum/solo-enum";
import { Subscription } from "rxjs";
import { OrganisationSettingService } from "src/app/_services/organisation-setting/organisation-setting.service";
import { ToastrService } from "ngx-toastr";
import { OrganisationFeedback } from "src/app/_models/feedback/feedback";
import { CommonModule } from "@angular/common";
import { ModalOneComponent } from "../../../shared/design-system/modal-one/modal-one.component";
import { ButtonComponent } from "../../../shared/design-system/button/button.component";
import { ICONS } from "../../../_helpers/icons.constants";
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ButtonConfig } from "../../design-system/button/button.modal";

@Component({
    selector: "feedback-panel",
    templateUrl: "./feedback-panel.component.html",
    standalone: true,
    imports: [TranslateModule ,CommonModule, ModalOneComponent, ButtonComponent]
})
export class FeedbackPanelComponent implements OnInit, OnDestroy {
  public ICONS = ICONS;
  public calendlyUrl: string = environment.calendlyUrl;
  public safeCalendlyUrl: SafeResourceUrl; 
  @Input() type: number;
  @Output() closePanel = new EventEmitter();
  showSuccess: boolean = false;
  claims: Claims;
  claimSubscription: Subscription;
  userName: string = "";
  userEmail: string = "";
  isOnboardingFeedback: boolean = false;
  isTrialFeedback: boolean = false;
  isYesChecked: boolean = false;
  isNoChecked: boolean = false;
  feedbackTypeText: string = "";
  onboardingFeedbackText: string = "";
  showCalendly: boolean = false;
  bookNowConfig! : ButtonConfig;
  feedbackYesConfig! : ButtonConfig;
  backConfig! : ButtonConfig;
  doneConfig! : ButtonConfig;

  constructor(
    private translate: TranslateService,
    private toastr: ToastrService,
    private claimsService: ClaimsService,
    private organisationSettingService: OrganisationSettingService,
    private sanitizer: DomSanitizer,

  ) {
    this.claimSubscription = this.claimsService.currentClaims.subscribe((claims: Claims) => {
      this.claims = claims;
      if (claims && claims.UserId) {
        this.userName = this.claims.FinanceManager.trimEnd();
        this.userEmail = this.claims.LoginId;
        this.modalOneConfig={...this.modalOneConfig, modalTitle: this.translate.instant('hi') + this.userName}
      }
    });
  }

    modalOneConfig={
      visible:this.showSuccess && !this.showCalendly,
      modalTitle:this.translate.instant('hi') + this.userName,
      modalTitleDescription: this.isOnboardingFeedback ? this.translate.instant('your_onboarding_is_complete') : this.translate.instant('trial_feedback')
    };
    bookModalConfig={
      visible: this.showCalendly,
      modalTitle: this.translate.instant('pricing_label_booknow')
    }

  ngOnInit() {
    this.initializePanel();
    this.safeCalendlyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.calendlyUrl);
    this.setButtonConfigs();
  }

  setButtonConfigs() {
    this.bookNowConfig = {
      id:"booknow-button",
      label:this.translate.instant('pricing_label_booknow'),
      color:"primary-tertiary",
      size:"lg",
      ariaLabel:this.translate.instant('pricing_label_booknow')
    };
    this.feedbackYesConfig = {
        id:"onboarding-yes-button",
        label:this.translate.instant('onboarding_feedback_yes'),
        color:"primary",
        size:"lg",
        ariaLabel:this.translate.instant('onboarding_feedback_yes')
    };
    this.backConfig = {
      id:"back-button",
      label:this.translate.instant('go_back'),
      disabled:false,
      color:"primary-tertiary" ,
      size:"lg"
    };
    this.doneConfig = {
      id:"done-button",
      label:this.translate.instant('done'),
      disabled:false,
      color:"primary",
      size:"lg"
    };
  }

  ngOnDestroy() {
    this.claimSubscription.unsubscribe();
  }

  initializePanel() {
    if (this.type == OrgFeedbackTypes.OnboardingFeedback || this.type == OrgFeedbackTypes.TrialFeedback) {
      this.organisationSettingService.isFeedbackSubmitted(this.type).subscribe((result: boolean) => {
        if (!result) {
          if (this.type == OrgFeedbackTypes.OnboardingFeedback) {
            this.isOnboardingFeedback = true;
          }
          else if (this.type == OrgFeedbackTypes.TrialFeedback) {
            this.isTrialFeedback = true;
          }
          this.showSuccess = true;
          this.modalOneConfig={...this.modalOneConfig, visible:this.showSuccess && !this.showCalendly,
            modalTitleDescription: this.isOnboardingFeedback ? this.translate.instant('your_onboarding_is_complete') : this.translate.instant('trial_feedback')
          }
        }
        else {
          this.closeFeedbackPanel();
        }
      });
    }
  }

  onOptionChange(status: boolean) {
    this.isYesChecked = status;
    this.isNoChecked = !status;
    if (this.isOnboardingFeedback && this.isNoChecked) {
      this.showCalendly = true;      
      this.showSuccess = false;
    }
    else{
      this.onSubmitFeedback();
      this.showSuccess = false;
    }
    this.modalOneConfig={...this.modalOneConfig, visible:this.showSuccess && !this.showCalendly};
    this.bookModalConfig= {...this.bookModalConfig, visible: this.showCalendly};
  }

  goBackFromCalendly() {
    this.showCalendly = false;
    this.showSuccess = true;
    this.modalOneConfig={...this.modalOneConfig, visible:this.showSuccess && !this.showCalendly};
    this.bookModalConfig= {...this.bookModalConfig, visible: this.showCalendly};
  }

  onSubmitFeedback() {
    if (!this.isNoChecked && !this.isYesChecked) {
      this.toastr.error(this.translate.instant('feedback_selectoption'));
      return;
    }
    if (this.type == OrgFeedbackTypes.OnboardingFeedback) {
      this.feedbackTypeText = this.isYesChecked ? this.translate.instant("onboarding_feedback_yes") : this.translate.instant("onboarding_feedback_no");
    }
    else if (this.type == OrgFeedbackTypes.TrialFeedback) {
      this.feedbackTypeText = this.isYesChecked ? this.translate.instant("trial_feedback_yes") : this.translate.instant("trial_feedback_no");
    }
    const model = new OrganisationFeedback(this.userName, this.userEmail, this.type, this.feedbackTypeText, this.isYesChecked, this.onboardingFeedbackText)
    this.organisationSettingService.SubmitOrgFeedback(model).subscribe((result: boolean) => {
      if (result) {
        if (this.isYesChecked) {
          this.toastr.success(this.translate.instant("feedback_submitsuccess"))
        }
        this.closeFeedbackPanel();
      }
      else {
        this.toastr.error(this.translate.instant("feedback_submiterror"));
      }
    });

  }

  closeFeedbackPanel() {
    this.closePanel.emit();
  }

}
